import { FC } from "react";
import { formatDateCustom } from "@app/shared/formatDateTime";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface NewProviderReportReportingPeriodNoticeProps {
  publishedRunDate: string | Date;
  reportingPeriodDays: number;
}

const formatPublishedRunDate = (publishedRunDate: string | Date): string =>
  formatDateCustom(publishedRunDate, "LL [at] LT");

const NewProviderReportReportingPeriodNotice: FC<NewProviderReportReportingPeriodNoticeProps> = ({ publishedRunDate, reportingPeriodDays }) => {
  return (
    <div
      className="d-flex align-items-center text-info mt-2"
      data-testid="new-provider-report__reporting-period-notice"
      role="note"
    >
      <QesIcon
        iconName={QesIcons.InfoCircle}
        description="Information"
        className="flex-shrink-0 me-2"
        width="20"
      />
      <span>
        Reflects your network for the {reportingPeriodDays} days leading up to your most recent published run (<span className="fw-bold">{formatPublishedRunDate(publishedRunDate)}</span>).
      </span>
    </div>
  );
};

export default NewProviderReportReportingPeriodNotice;
